export default "__VITE_ASSET__DXEgUO_A__"